import React, { useRef } from 'react';
import { useParallax } from '../hooks/useParallax';

function Hero() {
  const parallaxRef = useRef(null);
  useParallax(parallaxRef);

  return (
    <section className="cardSection text-white">
      <div className="parallax-container" ref={parallaxRef}>
        <div className="parallax-background"></div>
      </div>
      <div className="container">
        <h1 className="f-74 text-center mt-50 wow animate__animated animate__fadeInUp">
          Review & Ranked The<br />Best Books
        </h1>
        <p className="f-white w-400 f-22 text-center wow animate__animated animate__fadeInDown">
          Find the best casinos, sportsbooks, and wagers in your State!
        </p>
      </div>
    </section>
  );
}

export default Hero;

